import { render } from "./index.vue?vue&type=template&id=ad99863a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/home-sub-banner/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad99863a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad99863a', __exports__)) {
    api.reload('ad99863a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ad99863a", () => {
    api.rerender('ad99863a', render)
  })

}


export default __exports__